$(document).ready(function () {

  if($('#new-diamond-diaries-header-drawer').length > 0){
    $('#new-diamond-diaries-header-toggle').click(function (e) {
      e.preventDefault();
      $('#new-diamond-diaries-header').toggleClass('mobile-menu-open');
    });
    $('.new-diamond-diaries-header-drawer-overlay').click(function (e) {
      $('#new-diamond-diaries-header').removeClass('mobile-menu-open');
    });

    $('#new-diamond-diaries-header-drawer .header-drawer-link[href^="#"]').click(function (e) {
      $('#new-diamond-diaries-header').removeClass('mobile-menu-open');
    });
  }
  
  if($('[data-diamond-diaries-video]').length > 0){
    $('[data-diamond-diaries-video]').on('click', function (e) {
      if ($(e.target).is('video') || $(e.target).closest('video').length) {
        return;
      }
      const current = $(this);
      const currentVideo = current.find('video')[0];
      $('[data-diamond-diaries-video].play-video').each(function () {
        if (this !== current[0]) {
          const otherVideo = $(this).find('video')[0];
          if (otherVideo) otherVideo.pause();
          $(this).removeClass('play-video');
        }
      });
  
      if (current.hasClass('play-video')) {
        current.removeClass('play-video');
        if (currentVideo) currentVideo.pause();
      } else {
        current.addClass('play-video');
        current.addClass('show-video');
        if (currentVideo) {
          currentVideo.play();
          // $(currentVideo).prop('muted', false);
        }
      }
    });
  
    $('video').on('play', function () {
      const parent = $(this).closest('[data-diamond-diaries-video]');
      $('[data-diamond-diaries-video]').not(parent).each(function () {
        $(this).removeClass('play-video');
        const otherVideo = $(this).find('video')[0];
        if (otherVideo) otherVideo.pause();
      });
      parent.addClass('play-video');
    });
    
  }

  if($('[data-diamond-diaries-faq]').length > 0){
    $('[data-diamond-diaries-faq] [data-diamond-diaries-toggle]').click(function (e) {
      e.preventDefault();
      $(this).next('[data-diamond-diaries-content]').slideToggle().parents('[data-diamond-diaries-faq]').toggleClass('active');
    });
  }
  
  if($('#why-diamond-tab-head').length > 0){

    const why_diamomnd_thumb_slider = new Swiper("#why-diamond-tab-head", {
      loop: false,
      spaceBetween: 20,
      slidesPerView: 1.5,
      watchSlidesProgress: true,
      centeredSlides: true,
      breakpoints: {
        769: {
          slidesPerView: 4,
          centeredSlides: false,
        }
      },
    });
    
    const why_diamomnd_tab_slider = new Swiper('.why-diamond-content', {
      loop: false,
      slidesPerView: 1,
      slideToClickedSlide: true,
      spaceBetween: 20,
      effect: "fade",
      fadeEffect: {
        crossFade: true
      },
      grabCursor: false,
      allowTouchMove: false,
      on: {
        slideChange: function() {
          const sliderEl = this.el;
          var curr_slide = this.realIndex + 1;
          $(sliderEl).find('video').each(function () {
            this.pause();
            $(this).closest('[data-diamond-diaries-video]').removeClass('play-video');
          });
        }
      },
      thumbs: {
        swiper: why_diamomnd_thumb_slider,
      },
    });

    why_diamomnd_thumb_slider.on('slideChange', function () {
      const newIndex = this.realIndex;
      why_diamomnd_tab_slider.slideTo(newIndex);
    });

    why_diamomnd_thumb_slider.slides.forEach((slide, index) => {
      slide.addEventListener('click', () => {
        if (window.innerWidth < 769) {
          why_diamomnd_thumb_slider.slideTo(index);
        }
      });
    });

    // $('[data-why-diamond-toggle]').click(function (e) {
    //   e.preventDefault();
    //   var index = $(this).data('why-diamond-toggle');
    //   $(this).addClass('current');
    //   $(this).siblings().removeClass('current');
    //   why_diamomnd_tab_slider.slideTo(index - 1)
    // });
  }

  if($('.mobile_login_link').length > 0){ 
    var userAgent_login = navigator.userAgent || navigator.vendor || window.opera;
    if (/Mac|iPad|iPhone|iPod/.test(userAgent_login)) {
        var get_ios_button_val = $('.mobile_login_link').attr('data-ios_app_link');
        $('.mobile_login_link').attr('href',get_ios_button_val);
    } else {
        var get_and_button_val = $('.mobile_login_link').attr('data-android_app_link');
        $('.mobile_login_link').attr('href',get_and_button_val);
    }
  }


  if($('.inner_time_text').length > 0 && typeof window.end_date != 'undefined'){
    // Set the date we're counting down to
    // var countDownDate = new Date(window.end_date).toLocaleString("en-US", {timeZone: "America/Vancouver"});
    var countDownDate = new Date(window.end_date).getTime();

   
    console.log(new Date(window.end_date).toLocaleString("en-US", {timeZone: "America/Vancouver"}), 'countDownDatecountDownDate'); 
    console.log(new Date().toLocaleString("en-US", {timeZone: "America/Vancouver"}), 'newDatenewDatenewDatenewDate');
    // Update the count down every 1 second
    var x = setInterval(function() {
    
      // Get today's date and time
      var now = new Date().toLocaleString("en-US", {timeZone: "America/Vancouver"});
      now = new Date(now).getTime();
        
      // Find the distance between now and the count down date
      var distance = countDownDate - now;
        
      // Time calculations for days, hours, minutes and seconds
      var days = Math.floor(distance / (1000 * 60 * 60 * 24));
      var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      var seconds = Math.floor((distance % (1000 * 60)) / 1000);

      var days = formatTime(days);
      var hours = formatTime(hours);
      var minutes = formatTime(minutes);
      var seconds = formatTime(seconds);

      function formatTime(time){
        return time < 10 ? `${time}` : time;
      }
        
      // Output the result in an element with id="demo"
      var html = "<span class='time_day'><span class='timer_number'>" + days + "</span><span class='timer_text'>Days</span></span><span class='time_dots'>:</span><span class='time_hours'><span class='timer_number'>" + hours + "</span><span class='timer_text'>Hours</span></span><span class='time_dots'>:</span><span class='time_minutes'><span class='timer_number'>" + minutes + "</span><span class='timer_text'>Minutes</span></span><span class='time_dots'>:</span><span class='time_seconds'><span class='timer_number'>" + seconds + "</span><span class='timer_text'>Seconds</span>" + "</span>";
      $('.inner_time_text').html(html);
        
      // If the count down is over, write some text 
      if (distance < 0) {
        clearInterval(x);
        var exHtml = "<span class='time_day'><span class='timer_number'>00</span><span class='timer_text'>Days</span></span><span class='time_dots'>:</span><span class='time_hours'><span class='timer_number'>00</span><span class='timer_text'>Hours</span></span><span class='time_dots'>:</span><span class='time_minutes'><span class='timer_number'>00</span><span class='timer_text'>Minutes</span></span><span class='time_dots'>:</span><span class='time_seconds'><span class='timer_number'>00</span><span class='timer_text'>Seconds</span>" + "</span>";
        $('.inner_time_text').html(exHtml);
      }
    }, 1000);
  }

  $(window).scroll(function() {    
    var scroll = $(window).scrollTop();
    if(scroll > 60) {
      $(".new-diamond-diaries-header").addClass("DarkHeader");
    } else {
      $(".new-diamond-diaries-header").removeClass("DarkHeader");
    }
  });

  if($('.package-btn-and_link').length > 0){
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;
    if (/Mac|iPad|iPhone|iPod/.test(userAgent)) {
      $('.package-btn-and_link').each(function () {
        var link = $(this).data('ios-link');
        var text = $(this).text();
        if(link){
          $(this).replaceWith('<a href="'+link+'" class="pack-cta-button package-btn-and_link">'+text+'</a>')
        }
      });
    }
  }
  
})